import { isBrowser } from './is-browser';
/**
 * Проверяет наличие приложения в кеше
 * @param name
 */
export function hasApp(name) {
    var _a;
    return isBrowser() && !!((_a = window.apps) === null || _a === void 0 ? void 0 : _a[name]);
}
/**
 * Получает приложение из кеша
 * @param name
 */
export function getApp(name) {
    var _a;
    return (isBrowser() && ((_a = window.apps) === null || _a === void 0 ? void 0 : _a[name])) || null;
}
/**
 * Добавляет приложение в кеш
 * @param name
 * @param app
 */
export function setApp(name, app) {
    if (isBrowser()) {
        window.apps[name] = app;
    }
}
